import { DEFAULT_VIEWER_LOCALE } from "@garimpa/lib/viewerPreferences";

interface FeaturePageAlternate {
  locale: string;
  url: string;
}

export function featurePageAlternateLinks(alternates: FeaturePageAlternate[]) {
  const links = alternates.map((alternate) => ({
    rel: "alternate",
    hrefLang: alternate.locale,
    href: alternate.url,
  }));
  const defaultAlternate = alternates.find(
    (alternate) => alternate.locale === DEFAULT_VIEWER_LOCALE,
  );
  if (defaultAlternate) {
    links.push({ rel: "alternate", hrefLang: "x-default", href: defaultAlternate.url });
  }
  return links;
}
